import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getEquipmentFactplaces(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACES,
		options
	)
}

function _getEquipmentFactplace(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACE,
		options
	)
}

function _createEquipmentFactplace(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].CREATE_EQUIPMENT_FACTPLACE,
		options
	)
}

function _patchEquipmentFactplace(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PATCH_EQUIPMENT_FACTPLACE,
		options
	)
}

function _putEquipmentFactplace(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PUT_EQUIPMENT_FACTPLACE,
		options
	)
}

function _deleteEquipmentFactplace(options = {}) {
	return _apiRequestWrap(
		ModulesMap.EQUIPMENT_FACTPLACES,
		ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].DELETE_EQUIPMENT_FACTPLACE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACES]: _getEquipmentFactplaces,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].GET_EQUIPMENT_FACTPLACE]: _getEquipmentFactplace,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].CREATE_EQUIPMENT_FACTPLACE]: _createEquipmentFactplace,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PATCH_EQUIPMENT_FACTPLACE]: _patchEquipmentFactplace,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].PUT_EQUIPMENT_FACTPLACE]: _putEquipmentFactplace,

	[ModulesConfigMap[ModulesMap.EQUIPMENT_FACTPLACES].DELETE_EQUIPMENT_FACTPLACE]: _deleteEquipmentFactplace,
}
